function trackEvent(eventDetail) {
  // 确保window.ued和window.ued.bi存在
  if (!window.ued || !window.ued.bi || !window.ued.bi.E || !window.ued.bi.track) {
    console.warn('trackEvent: window.ued.bi.track is not available');
    return;
  }
  
  const event = {
    clientName: "ued_newgame_v2test",
    eventName: window.ued.bi.E.CUSTOM,
    eventDetail,
  };
 
  try {
    window.ued.bi.track(event);
  } catch (error) {
    console.error('Error in trackEvent:', error);
  }
};

const isNewVersion = $('.gb-final-newgame-v2').length > 0;
if (isNewVersion) {
  trackEvent('newgame_pageview-v2');
} else {
  trackEvent('newgame_pageview');
}
